// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3tDxQ","right":"styles_right__Y-71K"};